import React, { useRef, useState, useEffect } from "react";

import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination";
import ReactFileReader from "react-file-reader";
import { utils, read } from "xlsx";
import moment from "moment";
const FarmerPlotUpload = (props) => {
  const frmRef = useRef({});
  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();
  const [attachmentUrl, setAttachmentUrl] = useState();

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  //console.log(integerPattern);

  const { sendRequest: postAddVendor } = useHttp();

  const [data, setData] = useState([]);
  const [farmerIdlist, setFarmerIdlist] = useState([]);  
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();
  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);
  const [farmerData, setFarmerData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const [gradeData, setGradeData] = useState([]);
  const [varietiesData, setVarietiesData] = useState([]);
  
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, { header: 1 });

    //console.log("parsedData", parsedData);
    var count = parsedData.length;
    var newList = [];
    const now = new Date();
    const secondsSinceEpoch = Math.round(now.getTime() / 1000);
    const cropIdformat= ("1").toString().concat(secondsSinceEpoch.toString())
    //console.log("varietiesData", varietiesData);
    
    

    for (var k = 1; k < count ; k++) {
      var item = parsedData[k];
      //console.log("item", item);
      if (item[0] != "") {
        var liveStock = false;

        if ((item[3] ?? "") != "") {
          var regionId = 0;
          var fieldExecutiveId = 0;
        
          var farmerCode = item[0];
          var varietyName = item[10];
          var cropMasterId = 0;
          var cropVarietyId = 0;
          var otherShares = false;
          var farmerId = 0;
          var class1Rate=0;
          var class2Rate=0;
          var class3Rate=0;
          var classUnitId=0;
          var qtyUnitName="";
          
          var farmerlist = farmerData.filter(
            (item1) => item1.farmerNo.trim() == farmerCode.trim()
          );          
          if (farmerlist && farmerlist.length > 0) {
            farmerId = farmerlist[0].farmerId;
            fieldExecutiveId= farmerlist[0].fieldExecutiveId;
          }
           
           //console.log("varietyName", varietyName);
           var varietylist = varietiesData.filter(
            (item1) => item1.varietyName.trim() == varietyName.trim()
          );
          //console.log("varietylist", varietylist);
          if (varietylist && varietylist.length > 0) {
            cropMasterId = varietylist[0].cropId;
            cropVarietyId = varietylist[0].varietyId;
           
          }

          var gradefilterList = gradeData.filter(
            (item1) => item1.varietyId == cropVarietyId 
          );

          if (gradefilterList && gradefilterList.length > 0) {
            class1Rate = gradefilterList[0].class1Rate;
            class2Rate = gradefilterList[0].class2Rate;
            class3Rate = gradefilterList[0].class3Rate;
            qtyUnitName = gradefilterList[0].unitAbbreviation;
            classUnitId = gradefilterList[0].unitId;        
          }
         

           var cropId=cropIdformat.toString().concat(k.toString());
           
           newList = newList.concat({
            srNo: k,
            farmerId: farmerId,
            fieldExecutiveId:fieldExecutiveId,
            cropMasterId: cropMasterId,
            cropVarietyId: cropVarietyId,
            createdBy: fieldExecutiveId,
            farmerCode: item[0].toString().trim(),
            collectionCenter : item[1].toString().trim(),
            growerCode: item[2].toString().trim(),
            plotNo: item[3].toString().trim(),            
            cropId:cropId,
            plotName: item[4].toString().trim(),
            plotArea: item[5].toString().trim(),
            plotAreaUnit: item[6].toString().trim(),            
            status: 1,
            plotCoordinates: item[7].toString().trim(),
            cropType: item[8].toString().trim(),
            cropName: item[9].toString().trim(),
            cropVariety: item[10].toString().trim(),
            sowingDate: item[11]
              .toString()
              .replaceAll(/“/g, "")
              .replaceAll(/”/g, "")
              .trim(),
            pruningDate:item[12]
            .toString()
            .replaceAll(/“/g, "")
            .replaceAll(/”/g, "")
            .trim(),
            harvestingDate: item[13]
              .toString()
              .replaceAll(/“/g, "")
              .replaceAll(/”/g, "")
              .trim(),
            surveyNumberGutNumber: item[14].toString().trim(),
            class1Rate:class1Rate,
            class2Rate:class2Rate,
            class3Rate:class3Rate,
            qtyUnitName:qtyUnitName,
            classUnitId:classUnitId,
            dealDate:item[15]
            .toString()
            .replaceAll(/“/g, "")
            .replaceAll(/”/g, "")
            .trim(),
            dealEndDate: item[16]
              .toString()
              .replaceAll(/“/g, "")
              .replaceAll(/”/g, "")
              .trim(), 
             

            orgId: localStorage.getItem("orgId").toString().trim(),
          });
        }
      }
    }
    //console.log("newList", newList);
    var farmerIdData = [
      ...new Set(newList.map((q) => q.farmerId)),
    ];
    //console.log("farmerIdData", farmerIdData);
    setFarmerIdlist(farmerIdData);
    setData(newList);
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    var count=farmerIdlist.length;

    const now = new Date();
    const secondsSinceEpoch = Math.round(now.getTime() / 1000);
    const cropIdformat= ("1").toString().concat(secondsSinceEpoch.toString())
   
    var newList = [];
    var p=1;
    for (var k = 0; k < count ; k++) 
    {
      var farmerId= farmerIdlist[k]
      
      var plotNewList = [];
      var cropNewList = [];
      var contractNewList = {}; 
      var ContractplotNewList = [];

      var plotFilter = data.filter(
        (item1) => item1.farmerId == farmerId
      );

      var plotNoData = [
        ...new Set(plotFilter.map((q) => q.plotNo)),
      ];

      
      //console.log("plotNoData", plotNoData);
      var plotcount=plotNoData.length;
      for (var j = 0; j < plotcount ; j++) 
      {

       var plotId=secondsSinceEpoch.toString().concat(p.toString() )
       var plotNo= plotNoData[j]
       var selectedPlotList = plotFilter.filter(
          (item1) => item1.plotNo == plotNo
        );

        
        var cropsDetailList = [];
        var cropsIdList = [];
        var cropPlotcount=selectedPlotList.length;
        for (var i = 0; i < cropPlotcount ; i++) 
        {
          var cropId=cropIdformat.toString().concat((p++).toString() )
          
          
          cropNewList = cropNewList.concat({
            srNo: k,
            plotId: plotId,       
            cropMasterId:  selectedPlotList[i].cropMasterId,
            cropVarietyId:  selectedPlotList[i].cropVarietyId,
            createdBy: selectedPlotList[i].fieldExecutiveId,               
            cropId:cropId,                   
            status: 1,             
            cropType: selectedPlotList[i].cropType,
            cropName: selectedPlotList[i].cropName,
            cropVariety: selectedPlotList[i].cropVariety,
            sowingDate: selectedPlotList[i].sowingDate,
            pruningDate:selectedPlotList[i].pruningDate,
            harvestingDate:selectedPlotList[i].harvestingDate,
            surveyNumberGutNumber: selectedPlotList[i].surveyNumberGutNumber,
            class1Rate:selectedPlotList[i].class1Rate,
            class2Rate:selectedPlotList[i].class2Rate,
            class3Rate:selectedPlotList[i].class3Rate,
            qtyUnitName:selectedPlotList[i].qtyUnitName,
            classUnitId:selectedPlotList[i].classUnitId,
            receiptStatus:0,
            orgId: localStorage.getItem("orgId").toString().trim(),
          });
          cropsIdList= cropsIdList.concat(cropId)

           cropsDetailList = cropsDetailList.concat({
            cropType:selectedPlotList[i].cropType,
            cropName:selectedPlotList[i].cropName,
            class1Rate:selectedPlotList[i].class1Rate,
            class2Rate:selectedPlotList[i].class2Rate,
            class3Rate:selectedPlotList[i].class3Rate,
            sowingDate:selectedPlotList[i].sowingDate,
            classUnitId:selectedPlotList[i].classUnitId,
            cropVariety:selectedPlotList[i].cropVariety,
            pruningDate:selectedPlotList[i].pruningDate,
            cropMasterId:selectedPlotList[i].cropMasterId,
            cropVarietyId:selectedPlotList[i].cropVarietyId,
            harvestingDate:selectedPlotList[i].harvestingDate,
            surveyNumberGutNumber:selectedPlotList[i].surveyNumberGutNumber,
          })
           
           
        }

        //console.log("plotNoData", plotNoData);

        plotNewList = plotNewList.concat({
          srNo: k,
          farmerId: farmerId,       
          createdBy: selectedPlotList[0].fieldExecutiveId,
          plotNo: selectedPlotList[0].plotNo,            
          plotId:plotId,
          plotName: selectedPlotList[0].plotName,
          plotArea:selectedPlotList[0].plotArea,
          plotAreaUnit:selectedPlotList[0].plotAreaUnit, 
          cropsDetails:cropsDetailList ,        
          status: 1,
          plotCoordinates: selectedPlotList[0].plotCoordinates,
          orgId: localStorage.getItem("orgId").toString().trim(),
        });

        ContractplotNewList= ContractplotNewList.concat({
          plotId: plotId,
          cropIds: cropsIdList })

      }

      //console.log("plotNewList", plotNewList);

      var contractId=secondsSinceEpoch.toString().concat((k+1).toString() )
     
      contractNewList=  {
        contractId:contractId,
        farmerId: farmerId,       
        collectionCenter:  plotFilter[0].collectionCenter,
        growerCode: plotFilter[0].growerCode,            
        dealDate:  plotFilter[0].dealDate,
        dealEndDate: plotFilter[0].dealEndDate,         
        selectedCropDetails:JSON.stringify(ContractplotNewList) ,  
        orgId: localStorage.getItem("orgId").toString().trim(),
      };
 
     
      newList = newList.concat({
        plotList: plotNewList,
        cropList: cropNewList,
        contractList:contractNewList,
      });
    }
    //console.log("final newList", newList);
    postAddVendor(
      {
        url: "/api/uploadFarmerPlotfmn/",
        method: "POST",
        body: newList,
      },
      (data) => {
        toast.success(`farmer plot data uploaded`);
        setData([]);
      }
    );
  };

 

  const { sendRequest: getvarieties } = useHttp();
  useEffect(() => {
    getvarieties(
      {
        url: `/api/varieties/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
     
        setVarietiesData(data);
      }
    );
  }, [getvarieties]);

  const { sendRequest: getgrade } = useHttp();
  useEffect(() => {
    getgrade(
      {
        url: `/api/grade/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
     
        setGradeData(data);
      }
    );
  }, [getgrade]);

  
  const { sendRequest: getFarmerList } = useHttp();
  useEffect(() => {
    getFarmerList(
      {
        url: `/api/getFarmerList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
     
        setFarmerData(data);
      }
    );
  }, [getFarmerList]);


  
  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.data);
      }
    );
  }, [getEmp]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <div className="card">
                  <div className="card-body">
                    <div className="row"> </div>
                    <div className="row">
                      <div className="col-4">    <label className="card-title mx-2 my-3 ">
                          Farmer Plot Details
                        </label></div>
                      <div className="col-4"> </div>
                      <div className="col-2"> </div>
                      <div className="col-2">
                        <ReactFileReader
                          handleFiles={handleFileUpload}
                          fileTypes={".xlsx"}
                        >
                          <button
                            type="button"
                            className="btn  btn-primary mx-2 my-2"
                          >
                            Upload Excel
                          </button>
                        </ReactFileReader>
                      </div>
                    </div>
                    <div className="row"> </div>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4"> </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <thead>
                          <tr>
                            <th> Farmer Code</th> 
                            <th>Collection Center </th>
                            <th>Grower Code</th> 
                            <th>Plot No</th>
                            <th>Plot Name</th> 
                            <th>PlotArea</th>
                            <th>Plot Area Unit</th> 
                            <th>PlotCoordinates</th>
                            <th>CropType</th>
                             <th>Crop Name</th>
                            <th>Variety Name</th>
                             <th>Sowing Date</th>
                            <th>Pruning Date</th>
                             <th>Harvesting Date</th>
                            <th>Survey Number/Gut Number</th>
                          </tr>
                          
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.farmerCode}</td>
                                <td>{x.collectionCenter}</td>
                                <td>{x.growerCode}</td>                        
                                <td>{x.plotNo}</td>
                                <td>{x.plotName}</td>
                                <td>{x.plotArea}</td>
                                <td>{x.plotAreaUnit}</td>
                                <td>{x.plotCoordinates}</td>
                                <td>{x.cropType}</td>
                                <td>{x.cropName}</td>
                                <td>{x.cropVariety}</td>
                                <td>{x.sowingDate}</td>
                                <td>{x.pruningDate}</td>
                                <td>{x.harvestingDate}</td>
                                <td>{x.surveyNumberGutNumber}</td>   
                                
                                </tr>

 
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-1">
                    
                    <button
                      className="btn  btn-primary mx-2 my-2"
                      type="submit"
                      onClick={(e) => submitHandler(e)}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="col-md-1"></div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerPlotUpload;
